import { BasicLayout, StaticLayout } from '@shared/components';
import type { RouteRecordRaw } from 'vue-router';
import { basicPortalRouter, staticPortalRouter } from '@feature-portal/index';
/* #importFeatureRouter# */

// 业务路由
export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'BasicLayout',
    component: BasicLayout,
    meta: { hideInMenu: true }, // 此处加title会导致页面跳转缓慢时显示根路由的title
    children: [
      ...basicPortalRouter,
      /* #useFeatureRouter# */
    ],
  },
  // 静态页面路由，不需要走登录
  {
    path: '/',
    name: 'StaticLayout',
    component: StaticLayout,
    meta: { hideInMenu: true }, // 此处加title会导致页面跳转缓慢时显示根路由的title
    children: [...staticPortalRouter],
  },
  // TODO 统一空状态页面
  {
    path: '/static/error',
    name: 'loginError',
    component: () => import('@feature-error/loginError.vue'),
  },
  // 兜底的路由必须放在最后一个
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@feature-error/404.vue'),
  },
];
